module.exports = {"data":{"site":{"siteMetadata":{"title":"Yoga Flow | By Weekday Warriors"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 184
// module chunks = 60335399758886 114276838955818